import { useCart } from '@corratech/pylot-cart-manager'
import { useEffect, useRef, useState } from 'react'
import { useDataLayerAction } from '../TagContext'
import { CheckoutStepNameEnum, useStoreConfig } from 'config'

type CheckoutStepData = {
    step: CheckoutStepNameEnum
    option?: string
}

const isSameStepData = (
    step1?: CheckoutStepData,
    step2?: CheckoutStepData
): boolean => {
    return (
        !!step1 &&
        !!step2 &&
        step1.step === step2.step &&
        step1.option === step2.option
    )
}

const isCheckoutOptionEvent = (
    step1: CheckoutStepData,
    step2?: CheckoutStepData
): boolean => {
    return !!step1.option && !!step2?.option && step1.option !== step2?.option
}

export const useTrackCheckoutStep = (): ((data: CheckoutStepData) => void) => {
    const lastTrackedStepRef = useRef<CheckoutStepData>()
    const [stepData, setStepData] = useState<CheckoutStepData>()
    const { seo } = useStoreConfig()
    const { data } = useCart({
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateOnReconnect: false
    })
    const cart = data?.data?.cart
    const dataLayerAction = useDataLayerAction()
    useEffect(() => {
        if (
            stepData &&
            !isSameStepData(stepData, lastTrackedStepRef.current) &&
            cart
        ) {
            const eventData = {
                step: seo.checkoutSteps[stepData.step],
                option: stepData.option ?? stepData.step
            }
            if (isCheckoutOptionEvent(stepData, lastTrackedStepRef.current)) {
                dataLayerAction({
                    type: 'CHECKOUT_OPTION',
                    data: eventData
                })
            } else {
                dataLayerAction({
                    type: 'CHECKOUT',
                    data: { ...eventData, cart }
                })
            }
            lastTrackedStepRef.current = stepData
        }
    }, [stepData, cart])
    return setStepData
}
